<template>
	<div>
		<performance-review-editor
			:employees="employees"
			:logged-in-employee="loggedInEmployee"
			:default-discussion-points="defaultDiscussionPoints"
			:core-values="coreValues"
			:meeting-locations="meetingLocations"
			:templates="templates"
			:is-saving="isSaving"
			:employee-id="employeeId"
			@save="onSave"
			@cancel="onCancel"
		>
		</performance-review-editor>

		<v-footer color app height="55">
			<v-spacer></v-spacer>
			<footer-back-btn @click="onCancel" />
		</v-footer>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewEditor from '@/components/performanceReview/PerformanceReviewEditor';

	export default {
		name: 'PagePerformanceReview',
		components: {
			PerformanceReviewEditor
		},
		props: {
			employeeId: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				isSaving: false
			}
		},
		methods: {
			onSave(performanceReview) {
				this.isSaving = true;
				this.$store.dispatch('performanceReviews/add', performanceReview).then(
					data => {
						console.log('Performance Review added: ' + performanceReview);
						this.isSaving = false;
						this.$router.push(`/pr/${data.id}`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving performance review');
					}
				);
			},
			onCancel() {
				window.history.back();
			}
		},
		computed: {
			...mapGetters({
				employees: 'employees/employeesMiniActiveOnly',
				defaultDiscussionPoints: 'defaultDiscussionPoints/defaultDiscussionPoints',
				coreValues: 'coreValues/coreValues',
				loggedInEmployee: 'loggedInEmployee',
				meetingLocations: 'meetingLocations/meetingLocations',
				templates: 'performanceReviewTemplates/templates'
			})
		},
		created() {
			this.$store.dispatch('setPageTitle', 'New Performance Review');
		}
	};
</script>

<style></style>
